<template>
    <div v-if="allData.show">
        <v-card class="score-chart mx-1">
            <accommodationActionsType :actions="lateActions" action_type="overdue" action_avatar="mdi-clock-remove-outline" v-if="lateActions.length>0"/>
            <accommodationActionsType :actions="warnActions" action_type="upcoming" action_avatar="mdi-clock-alert-outline" v-if="warnActions.length>0"/>
            <accommodationActionsType :actions="otherActions" action_type="other" action_avatar="mdi-clock-outline" v-if="otherActions.length>0"/>
        </v-card>
    </div>
</template>

<script>
    import accommodationActionsType from "./accommodationActionsType.vue";

    export default {
        components: {
            accommodationActionsType
        },
        data() {
            return {
                allData: {
                    getAccommodationActions: [],
                    show: false,
                    iLate: 0,
                    iWarn: 0,
                    iOther: 0
                },
                lateActions: [],
                warnActions: [],
                otherActions: [],
            }
        },
        mounted () {
            this.getAccommodationActions();
        },
        methods:{
            getAccommodationActions() {
                this.lateActions = [];
                this.warnActions = [];
                this.otherActions = [];
                this.$axios.post("ares/json/ares/syst/dashboard/getAccommodationActions.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "getAccommodationActions"
                    },
                    getAccommodationActions: {
                    }
                }).then(res => {
                    if (res.data.error) {
                        console.log(res.data.error);
                    } else {
                        this.allData = res.data;
                        this.loading = false;
                        for (let iIndex=0;iIndex<res.data.getAccommodationActions.length;iIndex++) {
                            if (res.data.getAccommodationActions[iIndex].action_type === "Late") {
                                this.lateActions.push(res.data.getAccommodationActions[iIndex]);
                            }
                            if (res.data.getAccommodationActions[iIndex].action_type === "Warn") {
                                this.warnActions.push(res.data.getAccommodationActions[iIndex]);
                            }
                            if (res.data.getAccommodationActions[iIndex].action_type === "Other") {
                                this.otherActions.push(res.data.getAccommodationActions[iIndex]);
                            }
                        }
                    }
                });
            }, 
        }
    }
</script>

<style scoped>
    .score-chart {
        background-image: linear-gradient(#FF1100, #FFB400) !important;
        background-size: cover !important;
    }
</style>